import { CSSProperties } from 'react';

export const centerComponentInMiddleofView = {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
} as CSSProperties;

export const centerComponentInMiddleofViewWithoutAlignItems = {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
} as CSSProperties;
